import { render } from "./AssignedActivityCodeValueTable.vue?vue&type=template&id=bc3a9870&ts=true"
import script from "./AssignedActivityCodeValueTable.vue?vue&type=script&lang=ts"
export * from "./AssignedActivityCodeValueTable.vue?vue&type=script&lang=ts"

import "./AssignedActivityCodeValueTable.vue?vue&type=style&index=0&id=bc3a9870&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__